import React from "react";
import { SkeletonPagePolaris } from "../../components/shared/SkeletonPagePolaris";
import { WrapperPage } from "../../components/shared/WrapperPage";

// const InternalDesignTeams = React.lazy(() =>
//   import("../../components/members/InternalDesignTeams"),
// );

const InternalDesignTeams = React.lazy(() =>
  import("../../components/internal-team"),
);

export default function InternalDesignTeamPage() {
  return (
    <WrapperPage>
      <React.Suspense fallback={<SkeletonPagePolaris />}>
        <InternalDesignTeams />
      </React.Suspense>
    </WrapperPage>
  );
}
